import { AxiosInstance } from 'axios';
import { createContext } from 'react';
import {
  AttachmentsApi,
  EntityNamesApi,
  EntityTitlesApi,
  FlattenedIssueTypesApi,
  GovmapGroupsApi,
  GrcObjectsApi,
  IssueActionCountApi,
  IssuesApi,
  IssueSlasApi,
  IssueSubtypesApi,
  IssueTemplatesApi,
  IssueTypesApi,
  MonitoringApi,
  RelationshipsApi,
  SlasApi,
  UsersApi,
} from '../generated/api';

export interface ApiContextType {
  axios: AxiosInstance;
  issuesApi: IssuesApi;
  issueTypesApi: IssueTypesApi;
  issueSubtypesApi: IssueSubtypesApi;
  flattenedIssueTypesApi: FlattenedIssueTypesApi;
  usersApi: UsersApi;
  issueTemplatesApi: IssueTemplatesApi;
  issueSLAsApi: IssueSlasApi;
  issueEntityNamesApi: EntityNamesApi;
  issueActionCountApi: IssueActionCountApi;
  slasApi: SlasApi;
  govmapGroupsApi: GovmapGroupsApi;
  attachmentsApi: AttachmentsApi;
  monitoringApi: MonitoringApi;
  entityTitlesApi: EntityTitlesApi;
  relationshipsApi: RelationshipsApi;
  grcObjectsApi: GrcObjectsApi;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ApiContext = createContext<ApiContextType>({} as any);
